import { RewardTypeEnum } from "@/types/reward";
import Image from "next/image";
import { IconMap } from "@/app/[locale]/(main)/(non-activity)/reward/constants/rewardIcon";

interface RewardIconProps {
  type: RewardTypeEnum;
  className?: string;
  width?: number;
  height?: number;
}

export const RewardIcon = (props: RewardIconProps) => {
  const { type, className, width = 67, height = 55 } = props;
  const icon = IconMap[type];
  if (!icon) {
    return null;
  }
  return (
    <Image src={icon} alt='reward icon' width={width} height={height} className={className} />
  );
};
